import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
// import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  ButtonItem,
  ErrorItem,
  RangePickerItem
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import {
  texto,
  identificador,
  numero,
  moneda,
  totalizar,
  construirHojaTabla,
  descargarLibro,
  limpiarNombreArchivo,
} from "../../../../Components/ExcelTablaReporte";
import moment from "moment";
import "moment/locale/es";
// import { ResponsiveSwarmPlot } from "@nivo/swarmplot";
import reporteResumenEntradasSalidasPdf from "../../../../Pdf/reporteResumenEntradasSalidasPdf";



moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

// Un valor negativo ya no es un error de calculo del reporte: significa que el libro de
// entradas y salidas de ese insumo esta descuadrado (salidas valuadas por encima de las
// entradas). Se pinta en rojo para que se pueda ir a revisar ese insumo.
const marcarDescuadre = (texto, negativo) =>
  negativo ? (
    <span style={{ color: "#cf1322", fontWeight: 500 }}>{texto}</span>
  ) : (
    texto
  );

class ReporteResumenEntradasSalidas extends Component {
  state = {
    loading: false,
    pdf: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasInventario: [],
    dataGrafico: [],
    valorMaximoCirculo: 0
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    this.consultarReporteResumenEntradasSalidas({
      periodo: [moment().subtract(1, "month"), moment()],
    });
  }

  consultarReporteResumenEntradasSalidas(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeInventario/reporteResumenEntradasSalidas",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          // this.crearGrafico(
          //   res.data.inventario,
          // );
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasInventario: res.data.inventario,
          });
        } else if (res.data.success === 1) {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  /**
   * El periodo consultado y los filtros, en una linea.
   *
   * Es la razon de ser de este cambio: sin el periodo dentro del archivo, al
   * comparar dos cortes una clave que simplemente no tuvo movimiento en uno de
   * ellos se lee como una omision del reporte. El PDF ya lo traia; el Excel no.
   */
  descripcionFiltros() {
    const data = this.state.dataReporte;
    const partes = [];
    if (data?.rango?.startDate && data?.rango?.endDate) {
      partes.push(
        `Del ${moment(data.rango.startDate).format("DD/MM/YYYY")} al ${moment(
          data.rango.endDate
        ).format("DD/MM/YYYY")}`
      );
    }
    if (data?.filtrarProyecto === 1) {
      partes.push(`${(data.proyectos || []).length} proyecto(s)`);
    }
    if (data?.filtrarProyecto === 2 && data?.unidadDeNegocio?.nombre) {
      partes.push(`Unidad de negocio: ${data.unidadDeNegocio.nombre}`);
    }
    partes.push("Incluye apartados");
    return partes.join(" - ");
  }

  /** El sufijo del nombre de archivo: el periodo, no la fecha de descarga. */
  sufijoPeriodo() {
    const rango = this.state.dataReporte?.rango;
    if (!rango?.startDate || !rango?.endDate) return moment().format("YYYY-MM-DD");
    return `${moment(rango.startDate).format("YYYY-MM-DD")}_a_${moment(
      rango.endDate
    ).format("YYYY-MM-DD")}`;
  }

  /** Detalle por insumo. Cada columna suma normal + apartado, igual que la tabla. */
  construirTablaDetalle() {
    const columnas = [
      { titulo: "Codigo", tipo: "identificador", ancho: 16 },
      { titulo: "Clave", tipo: "identificador", ancho: 18 },
      { titulo: "Descripcion", tipo: "texto", ancho: 42 },
      { titulo: "Unidad", tipo: "texto", ancho: 12 },
      { titulo: "Marca", tipo: "texto", ancho: 18 },
      { titulo: "Familia", tipo: "texto", ancho: 20 },
      { titulo: "Inicial", tipo: "numero", ancho: 12 },
      { titulo: "Entradas", tipo: "numero", ancho: 12 },
      { titulo: "Salidas", tipo: "numero", ancho: 12 },
      { titulo: "Final", tipo: "numero", ancho: 12 },
      { titulo: "Costo Inicial", tipo: "moneda", ancho: 16 },
      { titulo: "Costo Entradas", tipo: "moneda", ancho: 16 },
      { titulo: "Costo Salidas", tipo: "moneda", ancho: 16 },
      { titulo: "Costo Final", tipo: "moneda", ancho: 16 },
    ];

    const filas = (this.state.todasInventario || []).map((v) => [
      identificador(v.codigoInsumo),
      identificador(v.claveInsumo),
      texto(v.descripcionInsumo),
      texto(v.nombreUnidad),
      texto(v.nombreMarca),
      texto(v.nombreFamilia),
      numero((v.inicial || 0) + (v.inicialApartado || 0)),
      numero((v.entradas || 0) + (v.entradasApartado || 0)),
      numero((v.salidas || 0) + (v.salidasApartado || 0)),
      numero((v.final || 0) + (v.finalApartado || 0)),
      moneda((v.costoTotalInicial || 0) + (v.costoTotalInicialApartado || 0)),
      moneda((v.costoTotalEntradas || 0) + (v.costoTotalEntradasApartado || 0)),
      moneda((v.costoTotalSalidas || 0) + (v.costoTotalSalidasApartado || 0)),
      moneda((v.costoTotalFinal || 0) + (v.costoTotalFinalApartado || 0)),
    ]);

    // Solo se totalizan las columnas de dinero: sumar "Inicial" entre insumos de
    // distinta unidad no significa nada, y `totalizar` ya lo respeta al mirar el
    // tipo declarado de cada columna.
    return { columnas, filas, totales: totalizar(columnas, filas) };
  }

  /** Hoja de totales globales. El tipo va por celda: cantidades y dinero conviven. */
  construirTablaTotales() {
    const r = this.state.dataReporte?.resumen || {};
    const ra = this.state.dataReporte?.resumenApartado || {};
    const columnas = [
      { titulo: "Metrica", tipo: "texto", ancho: 20 },
      { titulo: "Total", tipo: "texto", ancho: 18 },
    ];
    const filas = [
      [texto("Inicial"), numero((r.totalInicial || 0) + (ra.totalInicialApartado || 0))],
      [texto("Entradas"), numero((r.totalEntradas || 0) + (ra.totalEntradasApartado || 0))],
      [texto("Salidas"), numero((r.totalSalidas || 0) + (ra.totalSalidasApartado || 0))],
      [texto("Final"), numero((r.totalFinal || 0) + (ra.totalFinalApartado || 0))],
      [texto("Costo Inicial"), moneda((r.costoTotalInicial || 0) + (ra.costoTotalInicialApartado || 0))],
      [texto("Costo Entradas"), moneda((r.costoTotalEntradas || 0) + (ra.costoTotalEntradasApartado || 0))],
      [texto("Costo Salidas"), moneda((r.costoTotalSalidas || 0) + (ra.costoTotalSalidasApartado || 0))],
      [texto("Costo Final"), moneda((r.costoTotalFinal || 0) + (ra.costoTotalFinalApartado || 0))],
    ];
    // Sin fila de TOTAL: sumar cantidades con importes no significa nada.
    return { columnas, filas, totales: null };
  }

  descargarExcel() {
    const hojas = [
      {
        nombre: "Inventario (Normal+Ap.)",
        hoja: construirHojaTabla(this.construirTablaDetalle(), {
          titulo: "Resumen de Entradas y Salidas",
          empresaNombre: this.props.empresa,
          descripcionFiltros: this.descripcionFiltros(),
        }),
      },
    ];

    if (this.state.dataReporte?.resumen || this.state.dataReporte?.resumenApartado) {
      hojas.push({
        nombre: "Totales",
        hoja: construirHojaTabla(this.construirTablaTotales(), {
          titulo: "Resumen de Entradas y Salidas - Totales",
          empresaNombre: this.props.empresa,
          descripcionFiltros: this.descripcionFiltros(),
          sinAutofiltro: true,
        }),
      });
    }

    descargarLibro(
      hojas,
      limpiarNombreArchivo(
        `Reporte_Resumen_Entradas_Salidas_${this.sufijoPeriodo()}`
      )
    );
  }

  descargarPdf() {
    pdfMake
      .createPdf(reporteResumenEntradasSalidasPdf(this.state.dataReporte))
      .download(
        limpiarNombreArchivo(
          `Reporte_Resumen_Entradas_Salidas_${this.sufijoPeriodo()}`
        )
      );
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  render() {
    const columns = [
      {
        title: "Clave",
        dataIndex: "claveInsumo",
        key: "claveInsumo",
        sorter: (a, b) => (a.claveInsumo || "").localeCompare(b.claveInsumo || ""),
        buscar: "claveInsumo",
        ellipsis: true,
      },
      {
        title: "Descripción",
        dataIndex: "descripcionInsumo",
        key: "descripcionInsumo",
        sorter: (a, b) => (a.descripcionInsumo || "").localeCompare(b.descripcionInsumo || ""),
        buscar: "descripcionInsumo",
        ellipsis: true,
      },
      {
        title: "Unidad",
        dataIndex: "nombreUnidad",
        key: "nombreUnidad",
        sorter: (a, b) => (a.nombreUnidad || "").localeCompare(b.nombreUnidad || ""),
        buscar: "nombreUnidad",
        ellipsis: true,
      },
      {
        title: "Familia",
        dataIndex: "nombreFamilia",
        key: "nombreFamilia",
        sorter: (a, b) => (a.nombreFamilia || "").localeCompare(b.nombreFamilia || ""),
        buscar: "nombreFamilia",
        ellipsis: true,
      },
      {
        title: "Inicial",
        key: "inicial",
        align: "right",
        sorter: (a, b) => ((a.inicial || 0) + (a.inicialApartado || 0)) - ((b.inicial || 0) + (b.inicialApartado || 0)),
        ellipsis: true,
        render: (_, r) => (r.inicial || 0) + (r.inicialApartado || 0),
      },
      {
        title: "Entradas",
        key: "entradas",
        align: "right",
        sorter: (a, b) => ((a.entradas || 0) + (a.entradasApartado || 0)) - ((b.entradas || 0) + (b.entradasApartado || 0)),
        ellipsis: true,
        render: (_, r) => (r.entradas || 0) + (r.entradasApartado || 0),
      },
      {
        title: "Salidas",
        key: "salidas",
        align: "right",
        sorter: (a, b) => ((a.salidas || 0) + (a.salidasApartado || 0)) - ((b.salidas || 0) + (b.salidasApartado || 0)),
        ellipsis: true,
        render: (_, r) => (r.salidas || 0) + (r.salidasApartado || 0),
      },
      {
        title: "Final",
        key: "final",
        align: "right",
        sorter: (a, b) => ((a.final || 0) + (a.finalApartado || 0)) - ((b.final || 0) + (b.finalApartado || 0)),
        ellipsis: true,
        render: (_, r) => marcarDescuadre((r.final || 0) + (r.finalApartado || 0), r.cantidadFinalNegativa),
      },
      {
        title: "Costo Ini.",
        key: "costoTotalInicial",
        align: "right",
        sorter: (a, b) => ((a.costoTotalInicial || 0) + (a.costoTotalInicialApartado || 0)) - ((b.costoTotalInicial || 0) + (b.costoTotalInicialApartado || 0)),
        ellipsis: true,
        render: (_, r) => marcarDescuadre(((r.costoTotalInicial || 0) + (r.costoTotalInicialApartado || 0)).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }), r.costoInicialNegativo),
      },
      {
        title: "Costo En.",
        key: "costoTotalEntradas",
        align: "right",
        sorter: (a, b) => ((a.costoTotalEntradas || 0) + (a.costoTotalEntradasApartado || 0)) - ((b.costoTotalEntradas || 0) + (b.costoTotalEntradasApartado || 0)),
        ellipsis: true,
        render: (_, r) => ((r.costoTotalEntradas || 0) + (r.costoTotalEntradasApartado || 0)).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      },
      {
        title: "Costo Sa.",
        key: "costoTotalSalidas",
        align: "right",
        sorter: (a, b) => ((a.costoTotalSalidas || 0) + (a.costoTotalSalidasApartado || 0)) - ((b.costoTotalSalidas || 0) + (b.costoTotalSalidasApartado || 0)),
        ellipsis: true,
        render: (_, r) => ((r.costoTotalSalidas || 0) + (r.costoTotalSalidasApartado || 0)).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      },
      {
        title: "Costo Fin.",
        key: "costoTotalFinal",
        align: "right",
        sorter: (a, b) => ((a.costoTotalFinal || 0) + (a.costoTotalFinalApartado || 0)) - ((b.costoTotalFinal || 0) + (b.costoTotalFinalApartado || 0)),
        ellipsis: true,
        render: (_, r) => marcarDescuadre(((r.costoTotalFinal || 0) + (r.costoTotalFinalApartado || 0)).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }), r.costoFinalNegativo),
      },

    ];

    // Contadores de descuadre que manda el backend. Solo son > 0 cuando algun renglon
    // quedo negativo, y eso apunta a un problema en los movimientos de ese insumo, no
    // en el reporte.
    const resumen = (this.state.dataReporte && this.state.dataReporte.resumen) || {};
    const descuadres = [
      [resumen.renglonesCostoInicialNegativo, "costo inicial negativo"],
      [resumen.renglonesCostoFinalNegativo, "costo final negativo"],
      [resumen.renglonesCantidadFinalNegativa, "existencia final negativa"],
    ].filter((value) => value[0] > 0);
    const avisoDescuadre = descuadres.length
      ? descuadres
          .map(
            (value) =>
              `${value[0]} ${value[0] === 1 ? "renglon" : "renglones"} con ${value[1]}`
          )
          .join(", ") + "."
      : null;

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteResumenEntradasSalidas"
          onFinish={this.consultarReporteResumenEntradasSalidas.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Resumen Entradas y Salidas de Inventario"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="3" key="3" forceRender tab="Periodo">
                  <FormItem initialValue={[moment().subtract(1, "month"), moment()]} name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Niguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>
            {/* <div
                style={{
                  backgroundColor: "white",
                  padding: 15,
                  marginTop: 10,
                  marginBottom: 10,
                  height: "400px",
                }}
              >
                <h1 style={{ fontSize: "20px" }}>Grafico</h1>
                <ResponsiveSwarmPlot
                    data={this.state.dataGrafico}
                    groups={[ 'Cantidad' ]}
                    identity="id"
                    value="cantidad"
                    valueFormat={() => ''}
                    spacing={4}
                    gap={30}
                    valueScale={{ type: 'linear', min: 0, max: 'auto', reverse: false }}
                    size={{
                        key: 'volume',
                        values: [
                            0,
                            this.state.valorMaximoCirculo
                        ],
                        sizes: [
                            6,
                            30
                        ]
                    }}
                    forceStrength={0.2}
                    simulationIterations={100}
                    enableGridY={false}
                    margin={{ top: 80, right: 100, bottom: 80, left: 100 }}
                    axisTop={{
                        orient: 'top',
                        tickSize: 10,
                        tickPadding: 5,
                        tickRotation: 0,
                    }}
                    axisRight={null}
                    axisBottom={{
                        orient: 'bottom',
                        tickSize: 10,
                        tickPadding: 5,
                        tickRotation: 0,
                    }}
                    axisLeft={null}
                    colors={['#ff6633', '#33cccc', '#cccc33']}
                    colorBy="index"
                />
              </div> */}
            <div style={{ height: 10 }}></div>
            {avisoDescuadre && (
              <div
                style={{
                  backgroundColor: "#fff1f0",
                  border: "1px solid #ffa39e",
                  borderRadius: 5,
                  padding: "8px 12px",
                  marginBottom: 10,
                  fontSize: 13,
                }}
              >
                {avisoDescuadre} Un valor negativo indica que el libro de entradas y
                salidas de ese insumo esta descuadrado: sus salidas quedaron valuadas por
                encima de sus entradas. Revisa el Kardex del insumo para ubicar el
                movimiento.
              </div>
            )}
            <TableItem
              rowKey={(value) => value.insumoId.toString() + Math.random()}
              columns={columns}
              dataSource={this.state.todasInventario}
              size="small"
              pagination={false}
            />
            {/* <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
            {this.state.pdf && (
              <iframe
                title={"documentos"}
                style={{ width: "100%", height: "100vh" }}
                id="printPdf"
                name="printPdf"
              />
            )}
          </div> */}
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    empresa: state.empresa.nombre,
  };
};

export default connect(mapStateToProps)(ReporteResumenEntradasSalidas);
